import { Toaster } from 'react-hot-toast';

export default function AppToaster() {
    return (
        <Toaster
            position="bottom-right"
            containerStyle={{ zIndex: 999999 }}
            toastOptions={{
                duration: 3000,
                style: {
                    background: '#1e293b',
                    color: '#fff',
                    borderRadius: '8px',
                    padding: '12px 16px',
                },
                success: {
                    style: { background: '#16a34a' },
                },
                error: {
                    style: { background: '#dc2626' },
                },
            }}
        />
    );
}
